import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LayoutComponent } from 'src/app/modules/core/layout/layout.component';

import { AuthGuardService } from 'src/app/modules/core/services/auth-guard.service';

import { LoginComponent } from 'src/app/modules/admin/login/login.component';
import { DashboardComponent } from 'src/app/modules/admin/dashboard/dashboard.component';
import { TcbCouponsComponent } from 'src/app/modules/admin/tcb/tcb-coupons/tcb-coupons.component';

const routes: Routes = [
  { path: 'admin', component: LoginComponent },
  { path: 'admin/dashboard', component: LayoutComponent, data: { module:'admin' }, // Dashboard
    children: [
        { path: '', component: DashboardComponent, canActivate: [AuthGuardService], data: { module:'admin', menuCode: 'A-DA' } }
    ]
  },
  { path: 'admin/tcb', component: LayoutComponent, data: { module:'admin' }, // TCB coupon management
    children: [
        { path: '', component: TcbCouponsComponent, canActivate: [AuthGuardService], data: { module:'admin', menuCode: 'A-TCB' } }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
